import { useGetMedicalInfo, useMedicalInfo } from "#/components/carrot-plans/context/MedicalInfoContext"
import {
  ButtonFooterLayout,
  ContinueButton,
  RoutingFlowCheckboxGroup,
  RoutingFlowTitle,
  SkipButton,
  StepLayout,
  useConvertTranslatedLabel
} from "#/components/carrot-plans/shared"
import { useStateMachine } from "#/components/context/stateMachine/StateMachineV2"
import React, { ReactElement } from "react"
import { defineMessage, FormattedMessage, useIntl } from "react-intl"
import { Form } from "@carrotfertility/carotene-core-x"

const RACE_ETHNICITY_OPTIONS = [
  {
    label: defineMessage({ defaultMessage: "Black and/or African" }),
    value: "BLACK_AFRICAN"
  },
  {
    label: defineMessage({ defaultMessage: "Middle Eastern and/or North African" }),
    value: "MIDDLE_EASTERN_NORTH_AFRICAN"
  },
  { label: defineMessage({ defaultMessage: "White and/or European" }), value: "WHITE_EUROPEAN" },
  { label: defineMessage({ defaultMessage: "East Asian" }), value: "EAST_ASIAN" },
  {
    label: defineMessage({ defaultMessage: "South Asian" }),
    value: "SOUTH_ASIAN"
  },
  { label: defineMessage({ defaultMessage: "Southeast Asian" }), value: "SOUTHEAST_ASIAN" },
  {
    label: defineMessage({ defaultMessage: "Hispanic and/or Latine" }),
    value: "HISPANIC_LATINE"
  },
  {
    label: defineMessage({ defaultMessage: "Indigenous and/or First Nations" }),
    value: "INDIGENOUS_FIRST_NATIONS"
  },
  { label: defineMessage({ defaultMessage: "I prefer not to answer" }), value: "PREFER_NOT_TO_ANSWER" }
]

export default function RaceEthnicityStep(): ReactElement {
  const intl = useIntl()
  const { updateMedicalInfo, hasQuestionBeenSkipped } = useMedicalInfo()
  const { data: medicalInfo } = useGetMedicalInfo()
  const defaultValue = medicalInfo?.raceEthnicity

  const options = useConvertTranslatedLabel(RACE_ETHNICITY_OPTIONS)

  const { send } = useStateMachine(defaultValue || hasQuestionBeenSkipped("raceEthnicity") ? "" : null)

  const headerText = intl.formatMessage({
    defaultMessage: "Please describe your race/ethnicity. Select all that apply."
  })

  async function onClickContinue(values: { raceEthnicity: string[] }): Promise<void> {
    await updateMedicalInfo({ raceEthnicity: values?.raceEthnicity })
    send("")
  }

  async function onSkip(): Promise<void> {
    await updateMedicalInfo({ skipFields: ["raceEthnicity"] })
    send("")
  }

  return (
    <>
      <RoutingFlowTitle title={headerText} />
      <StepLayout
        header={<span id="raceEthnicity-label">{headerText}</span>}
        formElements={
          <Form
            onSubmit={onClickContinue}
            defaultValues={{
              raceEthnicity: defaultValue || []
            }}
          >
            <RoutingFlowCheckboxGroup name="raceEthnicity" aria-labelledby="raceEthnicity-label" options={options} />
            <ButtonFooterLayout
              continueButton={
                <ContinueButton>
                  <FormattedMessage defaultMessage="Continue" />
                </ContinueButton>
              }
              skipButton={<SkipButton onClick={onSkip} />}
            />
          </Form>
        }
      />
    </>
  )
}
